var policyServiceObj =
{
    getPolicyList(pageParams) {
        // return axios.get('api/Policy')
        return axios.post('api/Order/GetPage', pageParams)
    },

    getPolicyPageList(pageParams) {
        console.log('getOrdersPageList:');
        return axios.post('api/Order/GetPage', pageParams)
    },
    getPolicy(id) {
        // return axios.get('api/Policy/'+ id)
        return {};
    },
    savePolicy(id, policy) {
        console.log('savePolicy:' + id + ' Name:' + policy.Name)
        return axios.post('api/Policy', policy)
    },
    deletePolicy(id) {
        return axios.delete('api/Policy/' + id)
    }
}

export const policyService = policyServiceObj;
